import {
  DROPDOWN_SIZE,
  DSTooltip,
  Dropdown,
  DropdownButton,
  DropdownMenu,
  DropdownMenuItem,
} from '@repo/design-system/index'
import { QIcon_trash } from '@repo/icons/index'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import { IScheduleItem } from '../../../../modules/apis/student/lesson/schedule/types'
import { useCurrentUser } from '../../../../modules/context/UserContext'
import { n_book_lessons, s_common, s_schedule } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { formatDateWithDuration } from '../../../../modules/utils'
import { COLORS } from '../../../../modules/vars'

enum MATCHING_OPTION {
  NULL = null,
  DEFAULT_QUESTION = 0,
  DIFFERENT_TUTOR = 1,
  SHOW_TUTOR_AVAILABILITY = 2,
  RESTORE_CREDIT = 3,
}
const ScheduleItem = ({
  schedule,
  schedules,
  setSchedules,
  handleDeleteSchedule,
  isHideOption = false,
  setMatchingOption,
}: IScheduleItem) => {
  const { t, isLocaleKO } = useTranslation()
  const { currentUser } = useCurrentUser()
  const { duration, tutor, selectedTime, selectedTimeslot } = schedule
  const optionList = [
    {
      value: MATCHING_OPTION.DIFFERENT_TUTOR,
      label: t(s_schedule.get_matched_with_other_tutors_label),
    },
    {
      value: MATCHING_OPTION.RESTORE_CREDIT,
      label: t(s_schedule.recovering_a_used_class_ticket_after_canceling),
    },
  ]
  const [option, setOption] = useState(null)

  useEffect(() => {
    if (option) {
      setMatchingOption && setMatchingOption(option.value)
      const newData = {
        ...schedule,
        matchingAfter: option.value,
      }

      const tempSchedules = schedules.map((s) => {
        if (
          s.selectedTime?.timeslotId == schedule.selectedTime?.timeslotId ||
          s.selectedTimeslot?.id == schedule.selectedTimeslot?.id
        ) {
          return newData
        } else {
          return s
        }
      })
      setSchedules && setSchedules(tempSchedules)
    }
  }, [option])

  return (
    <div className="rounded-[10px] border-[1px] border-gray-100 bg-white">
      <div className="p-[16px]">
        <div className="flex items-center justify-between">
          <div className="border-none bg-gray-100 py-[2px] px-[4px]">
            <span className="text-[14px] font-bold text-gray-600">
              {duration}
              {t(s_common.minutesNoDash)}
            </span>
          </div>
          {handleDeleteSchedule && (
            <div className="cursor-pointer" onClick={() => handleDeleteSchedule(schedule)}>
              <QIcon_trash color={COLORS.GRAY400} width={20} height={20} />
            </div>
          )}
        </div>
        {selectedTime && (
          <div className="Title2-18Bd mt-[4px]">
            {formatDateWithDuration(selectedTime.classtime, duration, isLocaleKO)}
          </div>
        )}
        {selectedTimeslot && (
          <div className="Title2-18Bd mt-[4px]">{formatDateWithDuration(selectedTimeslot, duration, isLocaleKO)}</div>
        )}
        {tutor && (
          <div className="mt-[16px] flex">
            <div>
              <Image
                src={tutor.image_url}
                alt={tutor.first_name}
                width={40}
                height={40}
                className="max-h-[40px] min-h-[40px] min-w-[40px] max-w-[40px] rounded-[50%]"
              />
            </div>
            <div className="ml-[16px]">
              <div className="Body2-14Md text-black">{tutor.first_name}</div>
              <div className="Body2-14Md text-gray-500">{tutor.major}</div>
            </div>
          </div>
        )}
      </div>
      {!isHideOption && (
        <div>
          <div className="rounded-b-[10px] border-[1px] border-gray-200 bg-gray-50 p-[16px]">
            <div className="text-[14px] font-bold text-purple-600">{t(n_book_lessons.tutor_maching_option.title)}</div>
            <div className="Caption-12Md sm:Body2-14Md text-gray-700">
              {t(n_book_lessons.tutor_maching_option.subtitle)}
            </div>
            {setSchedules ? (
              <div className="mt-[8px] w-full bg-white">
                <Dropdown selected={option} setSelected={setOption} size={DROPDOWN_SIZE.MD} className="w-full">
                  {option &&
                  option.value == MATCHING_OPTION.DIFFERENT_TUTOR &&
                  currentUser.profile.finished_lesson_count == 0 ? (
                    <DSTooltip
                      place="top"
                      isMultiline={true}
                      isOpenOnClick={false}
                      triggerComponent={<DropdownButton>{option.label}</DropdownButton>}
                      contentComponent={t(n_book_lessons.tooltip_another_tutor_maching_1)}
                    />
                  ) : (
                    <DropdownButton wrapperClassName="w-full">
                      {option?.label || t(s_schedule.check_tutor_matching_option)}
                    </DropdownButton>
                  )}
                  {/* s_schedule.check_tutor_matching_option */}
                  <DropdownMenu className="w-full" wrapperClassName="w-full">
                    {optionList.map((item, i) => {
                      return (
                        <DropdownMenuItem key={i} value={item.value}>
                          {item.label}
                        </DropdownMenuItem>
                      )
                    })}
                  </DropdownMenu>
                </Dropdown>
              </div>
            ) : (
              <div className="mt-[8px] w-full">
                <div className="border-[1.5px] border-gray-200  bg-gray-100 py-[8px] px-[12px] Body2-14Md">
                  {optionList.find((option) => option.value == schedule.matchingAfter)?.label}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default ScheduleItem
